import { UserDetails } from "src/modules/user/pages/UserDetails/UserDetails";

const UserConfig = {
    routes: {
        userDetails: {
            path: '/users/:id-:slug',
            component: UserDetails,
        },
        userDetailsById: {
            path: '/users/:id',
            component: UserDetails,
        },
    },
}

export { UserConfig }
